import { random, round2Str } from "../helpers/helpers";

export const generate_outdoor_month_chart_demo = ({ year, month }) => {
    const daysInMonth = new Date(year, month, 0).getDate();
    const today = new Date();

    const daily_energy_data = [];

    for (let day = 1; day <= daysInMonth; day++) {
        const d = new Date(year, month - 1, day);
        if (d > today) break;

        daily_energy_data.push({
            day,
            avg_co: round2Str(random(400, 1600)),
            avg_co_monoxide: 0.0,
            avg_formaldehyde: "13.00",
            avg_humidity: round2Str(random(45, 60)),
            avg_no2: 0.0,
            avg_o3: 0.0,
            avg_pm10: round2Str(random(55, 80)),
            avg_pm2: round2Str(random(52, 78)),
            avg_smoke: round2Str(random(700, 1800)),
            avg_so2: 0.0,
            avg_temp: round2Str(random(25.5, 29.5)),
            avg_tvoc: round2Str(random(1800, 6000)),

            max_co: round2Str(random(1200, 3600)),
            max_co_monoxide: "0.00",
            max_formaldehyde: "13.00",
            max_humidity: round2Str(random(55, 70)),
            max_pm10: round2Str(random(90, 330)),
            max_pm2: round2Str(random(85, 320)),
            max_smoke: round2Str(random(1500, 9000)),
            max_temp: round2Str(random(27, 31)),
            max_tvoc: round2Str(random(5000, 30000)),

            min_co: round2Str(random(350, 600)),
            min_humidity: round2Str(random(40, 50)),
            min_pm10: round2Str(random(25, 50)),
            min_pm2: round2Str(random(22, 45)),
            min_smoke: round2Str(random(200, 800)),
            min_temp: round2Str(random(23, 26)),
            min_tvoc: round2Str(random(900, 1600)),
        });
    }

    return {
        daily_energy_data,
        is_co: true,
        is_co_monoxide: true,
        is_formaldehyde: true,
        is_humidity: true,
        is_no2: true,
        is_o3: true,
        is_pm10: true,
        is_pm2: true,
        is_smoke: true,
        is_so2: true,
        is_temperature: true,
        is_tvoc: true,
        month,
        year,
    };
};